exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".back-button[data-v-5aac5b93] {\n  padding-right: 1.25rem;\n  padding-left: 3.75rem;\n  text-align: left;\n}\n.back-icon[data-v-5aac5b93] {\n  -webkit-transform: translate(0, -50%);\n          transform: translate(0, -50%);\n}\n", ""]);

// exports
